import { isEqual } from "lodash";
import { useState } from "react";

import { ViaPlatformQuickFilter, ViaPlatformsOptions } from "./interfaces";

export const useViaPlatformQuickFilter = () => {
  const allOption = {
    viaAndroid: true,
    viaIPhone: true,
    viaWeb: true,
  };
  const [quickFilter, setQuickFilter] = useState<ViaPlatformQuickFilter>({
    viaPlatform: {
      viaPlatforms: [
        {
          ...allOption,
        },
      ],
    },
  });

  const [selectedValue, setSelectedValue] = useState<ViaPlatformsOptions>(quickFilter.viaPlatform.viaPlatforms[0]);

  const includesAllOption = (optionsList: ViaPlatformsOptions[]): boolean => {
    return !!optionsList.find((option) => option.viaAndroid && option.viaIPhone && option.viaWeb);
  };

  const handleChangeQuickFilter = (
    filter: keyof ViaPlatformQuickFilter,
    value: ViaPlatformQuickFilter["viaPlatform"]
  ) => {
    let optionsToInclude: ViaPlatformsOptions[] = [];

    let computedViaIPhone: boolean;
    let computedViaAndroid: boolean;
    let computedViaWeb: boolean;

    if (isEqual(value, quickFilter[filter])) return;

    //if the all option did not exist and user selects all newly => the other options option will be unselected except all

    if (includesAllOption(value.viaPlatforms) && !includesAllOption(quickFilter.viaPlatform.viaPlatforms)) {
      optionsToInclude = [allOption];

      computedViaIPhone = true;
      computedViaAndroid = true;
      computedViaWeb = true;
    } else if (includesAllOption(quickFilter.viaPlatform.viaPlatforms)) {
      //if the all option was selected and user selects another option=> allOption will be unselected
      optionsToInclude = value.viaPlatforms.filter(
        (option) => !(option.viaAndroid && option.viaIPhone && option.viaWeb)
      );
      computedViaIPhone = !!optionsToInclude.find((option) => option.viaIPhone);
      computedViaAndroid = !!optionsToInclude.find((option) => option.viaAndroid);
      computedViaWeb = !!optionsToInclude.find((option) => option.viaWeb);
    } else {
      optionsToInclude = value.viaPlatforms;

      computedViaIPhone = !!optionsToInclude.find((option) => option.viaIPhone);
      computedViaAndroid = !!optionsToInclude.find((option) => option.viaAndroid);
      computedViaWeb = !!optionsToInclude.find((option) => option.viaWeb);
    }

    setQuickFilter((state) => ({
      ...state,
      viaPlatform: {
        viaPlatforms: optionsToInclude,
      },
    }));

    setSelectedValue({
      viaIPhone: computedViaIPhone,
      viaAndroid: computedViaAndroid,
      viaWeb: computedViaWeb,
    });
  };

  return {
    viaPlatformQuickFilter: quickFilter,
    setViaPlatformQuickFilter: handleChangeQuickFilter,
    selectedViaPlatformValue: selectedValue,
  };
};
